var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal wrap",staticStyle:{"background":"#f2f2f2","min-height":"100vh","justify-content":"flex-start","align-items":"flex-start"}},[_c('CheckoutDesktop',{attrs:{"plan_slug":_vm.plan_slug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }